import { render, staticRenderFns } from "./CheckboxControl.vue?vue&type=template&id=47dbf65e&scoped=true&"
import script from "./CheckboxControl.vue?vue&type=script&lang=ts&"
export * from "./CheckboxControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dbf65e",
  null
  
)

export default component.exports